// FLAGS: none
// The catch-all route's screen; rendered outside the shell, so it is reachable signed-out.
import { Link } from "react-router";

const NotFoundPage = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-4 text-center">
    <h1 className="text-4xl font-semibold text-indigo-800">404</h1>
    <p className="text-gray-600">This page does not exist.</p>
    <Link
      to="/events"
      className="font-medium text-green-700 hover:text-green-900"
    >
      Back to events
    </Link>
  </div>
);

export default NotFoundPage;
